module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_6.892b4bd3.png";